import React, { useState, useEffect } from "react";
import IconConsult from "../../images/textConsult.svg";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MessageIcon from "@material-ui/icons/Message";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import VisibilityIcon from "@material-ui/icons/Visibility";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import IconButton from "@material-ui/core/IconButton";
import "../../styles/consultText.css";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MessageBody from "../providers/textconsultation/MessageBody";
import swal from "sweetalert";
import useUserState from "../hooks/useUserState";
import DashboardPatient from "../dashboard/DashboardPatient";
import useMessages from "../hooks/useMessages";
import useBDocTranslator from "../hooks/useBDocTranslator";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    height: "auto",
    minHeight: "600px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  drawer: {
    width: `calc(100% - ${drawerWidth}px)`,
    flexShrink: 0,
  },
  drawerPaper: {
    backgroundColor: "white",
    width: drawerWidth,
    border: "2px solid #dfdfdf",
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      flexDirection: "row",
      overflowX: "auto",
    },
  },
  divider: {
    width: 220,
    backgroundColor: "#dfdfdf !important",
  },
  dividerList: {
    width: "90%",
    backgroundColor: "#dfdfdf !important",
    marginLeft: "20px",
  },
  listIcon: {
    color: "#8e8e8e !important",
  },
  deletedIcon: {
    color: "#f96d6d !important",
  },
  answeredIcon: {
    color: "#47cc68 !important",
  },
  receivedIcon: {
    color: "#0077B6 !important",
  },
  // necessary for content to be below app bar
  toolbar: {
    zIndex: "1",
  },
  message: {
    width: "100%",
    borderRadius: "5px",
  },
  dashboard: {
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    border: "2px solid #dfdfdf",
    borderRadius: "10px",
  },
  listMessage: {
    width: "100%",
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  messageHeader: {
    width: "100%",
    height: "40px",
  },
  button: {
    width: "100px",
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
  },
}));

function InboxPatient(props) {
  const classes = useStyles();
  const { window } = props;
  const theme = useTheme();
  const [dashboard, setDashboard] = useState("received");
  const [messageSelected, setMessageSelected] = useState([]);
  const [messageContent, setMessageContent] = useState("");
  const [messageResponse, setMessageResponse] = useState("");
  const [checked, setChecked] = useState([0]);
  const [messages, setMessages] = useState([]);
  const persistedMsg = JSON.parse(sessionStorage.getItem("msg"));
  const [showMessage, setShowMessage] = useState(false);
  const [senderName, setSenderName] = useState("");
  const [patientEmail, setPatientEmail] = useState("");
  const [replyMessageId, setReplyMessageId] = useState("");
  const { t, changeDirectLanguage } = useBDocTranslator();

  //Persisted User Hook
  const userLocalState = useUserState();
  const currentUserId = userLocalState[0]?.user?.id;

  //Persisted Messages Hook
  const { replyToMessage, loading, updateMessage, getApiMessages } = useMessages("patient");

  // const handleToggle = (value) => () => {
  //     const currentIndex = checked.indexOf(value);
  //     const newChecked = [...checked];

  //     if (currentIndex === -1) {
  //     newChecked.push(value);
  //     } else {
  //     newChecked.splice(currentIndex, 1);
  //     }

  //     setChecked(newChecked);
  // };

  const handleBack = () => {
    if (dashboard === "receivedA") {
      setMessageContent("");
      setDashboard("received");
      setShowMessage(false);
      setSenderName("");
    }
    if (dashboard === "readA") {
      setMessageContent("");
      setDashboard("read");
      setShowMessage(false);
      setSenderName("");
    }
    if (dashboard === "answeredA") {
      setMessageContent("");
      setDashboard("answered");
      setShowMessage(false);
      setSenderName("");
    }
  };

  useEffect(() => {
    changeDirectLanguage();
    if (persistedMsg?.length > 0) {
      const sortMessages = persistedMsg.sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
      );

      setMessages(sortMessages);
    }
  }, []);

  const readMessages = messages.filter(
    (msg) =>
      msg.patient_receiver_status === "READ" &&
      !msg.thread?.some((t) => t.send_by_userid === currentUserId)
  );

  const answeredMessages = messages.filter((msg) =>
    msg.thread?.some((t) => t.send_by_userid === currentUserId)
  );

  const handleSetResponse = (message) => {
    setMessageResponse(message);
  };

  //Method for response the message
  // const handleResponseMessage = async () => {
  //   try {
  //     const msgObject = {
  //       send_by: userLocalState[0].user.email,
  //       send_to: patientEmail,
  //       createdAt: new Date(),
  //       status: "sended",
  //       content: messageResponse,
  //       sender_name: `${userLocalState[0].user.firstName} ${userLocalState[0].user.lastname}`,
  //     };
  //     if (messageResponse && replyMessageId && patientEmail) {
  //       //Update Patient Message Status to read by the Provider
  //       await db
  //         .collection("textConsultations-v2")
  //         .doc(replyMessageId)
  //         .update({
  //           modifiedAt: new Date(),
  //           action_request_status: "answered",
  //           action_response_status: "pending",
  //           response: firebase.firestore.FieldValue.arrayUnion(msgObject),
  //         });

  //       //cleaning params
  //       setMessageResponse("");
  //       setReplyMessageId("");
  //       setPatientEmail("");
  //       swal({
  //         title: "Success!",
  //         text: "Message sent",
  //         icon: "success",
  //         button: false,
  //       });
  //     } else {
  //       swal({
  //         title: "Failed!",
  //         text: "Plase write your message",
  //         icon: "error",
  //         button: false,
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     swal({
  //       title: "Failed!",
  //       text: "Something went wrong, please try againg later",
  //       icon: "error",
  //       button: false,
  //     });
  //   }
  // };

  const handleReply = async (send_to_userid) => {
    try {
      const msgObject = {
        send_by_userid: userLocalState[0].user.id,
        send_to_userid: send_to_userid,
        docId: replyMessageId,
        content: messageResponse,
        patient_receiver_status: "READ",
        provider_receiver_status: "UNREAD",
      };
      console.log(msgObject);
      if (messageResponse && replyMessageId) {
        //Update Patient Message Status to read by the Provider
        await replyToMessage(msgObject);
        await getApiMessages();
        const freshMessages = JSON.parse(sessionStorage.getItem("msg"));
        if (freshMessages?.length > 0) {
          const sorted = freshMessages.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
          );
          setMessages(sorted);
        }

        //cleaning params
        setMessageResponse("");
        setReplyMessageId("");
        swal({
          title: t("Success!"),
          text: t("Message sent"),
          icon: "success",
          button: false,
        });
      } else {
        swal({
          title: "Error!",
          text: t("Plase write your message"),
          icon: "error",
          button: false,
        });
      }
    } catch (error) {
      console.error(error);
      swal({
        title: "Error!",
        text: t("Something went wrong, please try againg later"),
        icon: "error",
        button: false,
      });
    }
  };

  // const handleMarkRead = async () => {
  //   try {
  //     await db
  //       .collection(`${process.env.REACT_APP_MESSAGES_COLLECTION}`)
  //       .doc(replyMessageId)
  //       .update({
  //         patient_receiver_status: "READ",
  //       });
  //     swal({
  //       title: "Success!",
  //       text: "Message Marked as Read",
  //       icon: "success",
  //       button: false,
  //     });
  //   } catch (error) {
  //     swal({
  //       title: "Failed!",
  //       text: "Something went wrong, please try againg later",
  //       icon: "error",
  //       button: false,
  //     });
  //   }
  // };

  const handleRefreshThread = async () => {
    await getApiMessages();
    const freshMessages = JSON.parse(sessionStorage.getItem("msg"));
    if (freshMessages?.length > 0) {
      const sorted = freshMessages.sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
      );
      setMessages(sorted);
      const updatedSelected = sorted.find((m) => m.id === messageSelected.id);
      if (updatedSelected) {
        setMessageSelected(updatedSelected);
      }
    }
  };

  const handleMarkRead = async (send_to_userid) => {
    try {
      const msgObject = {
        send_to_userid: send_to_userid,
        docId: replyMessageId,
        patient_receiver_status: "READ",
      };

      await updateMessage(msgObject);
      await getApiMessages();
      const freshMessages = JSON.parse(sessionStorage.getItem("msg"));
      if (freshMessages?.length > 0) {
        const sorted = freshMessages.sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
        );
        setMessages(sorted);
      }

      swal({
        title: t("Success!"),
        text: t("Message Marked as Read"),
        icon: "success",
        button: false,
      });
    } catch (error) {
      swal({
        title: "Error!",
        text: t("Something went wrong, please try againg later"),
        icon: "error",
        button: false,
      });
    }
  };

  return (
    <DashboardPatient
      sectionTitle={t("Text Consultations")}
      description={t(
        "Here you can find the responses of your Text Consultations grouped in Conservations"
      )}
      icon={IconConsult}
    >
      <div id="drawerContainer">
        <div
          className={
            classes.root +
            " m-3 p-3 shadow w-30 rounded-lg-custom bg-white d-flex"
          }
        >
          <div className={classes.drawerPaper + " py-1 px-2"}>
            <List>
              <ListItem
                onClick={() => {
                  setDashboard("received");
                  setMessageContent("");
                  setShowMessage(false);
                }}
                button
                className={classes.toolbar + " lisItem"}
              >
                <ListItemIcon className={classes.receivedIcon}>
                  <MessageIcon />
                </ListItemIcon>
                <ListItemText primary={`${t("Received")} (${messages.length})`} />
              </ListItem>

              <ListItem
                onClick={() => {
                  setDashboard("read");
                  setMessageContent("");
                  setShowMessage(false);
                }}
                button
                className={classes.toolbar + " lisItem"}
              >
                <ListItemIcon className={classes.receivedIcon}>
                  <VisibilityIcon />
                </ListItemIcon>
                <ListItemText primary={`${t("Read")} (${readMessages.length})`} />
              </ListItem>

              <ListItem
                onClick={() => {
                  setDashboard("answered");
                  setMessageContent("");
                  setShowMessage(false);
                }}
                button
                className={classes.toolbar + " lisItem"}
              >
                <ListItemIcon className={classes.answeredIcon}>
                  <CheckBoxIcon />
                </ListItemIcon>
                <ListItemText primary={`${t("Answered")} (${answeredMessages.length})`} />
              </ListItem>
            </List>
          </div>
          {dashboard === "received" && (
            <div
              className={
                classes.dashboard +
                " mx-1 flex-column justify-content-start py-3"
              }
            >
              <List className={classes.listMessage}>
                {/* Received Messages List  */}
                {loading && messages.length === 0 && (
                  <div className={classes.loadingContainer}>
                    <CircularProgress />
                  </div>
                )}
                {messages.length > 0 &&
                  messages.map((msg, idx) => {
                    return (
                      <React.Fragment key={idx}>
                        <ListItem
                          role={undefined}
                          dense
                          button
                          onClick={() => {
                            setShowMessage(true);
                            setMessageContent(msg.content);
                            setSenderName(msg.sender_name);
                            setDashboard(`${dashboard}A`);
                            setPatientEmail(msg.send_by);
                            setReplyMessageId(msg.id);
                            setMessageSelected(msg);
                          }}
                          className={classes.message + " lisItem my-2 p-2"}
                        >
                          <ListItemIcon className={classes.receivedIcon}>
                            <OpenInNewIcon />
                          </ListItemIcon>
                          <div className="mr-2">
                            <span
                              className={`badge badge-${
                                msg?.patient_receiver_status === "UNREAD"
                                  ? "success"
                                  : "secondary"
                              }`}
                            >
                              {msg?.patient_receiver_status === "UNREAD"
                                ? t("new")
                                : t("read")}
                            </span>
                          </div>
                          <ListItemText
                            primary={`${t("From")}: (${
                              msg.other_user?.extendedData?.firstName || ""
                            } ${
                              msg.other_user?.extendedData?.lastname || ""
                            }) at (${new Date(
                              msg.createdAt
                            ).toLocaleString()}) - ${t("Message Received")}`}
                          />
                        </ListItem>
                        <Divider className={classes.dividerList} />
                      </React.Fragment>
                    );
                  })}
                {messages.length === 0 && !loading && (
                  <div className={classes.emptyState}>
                    <MessageIcon style={{ fontSize: 48, opacity: 0.3 }} />
                    <Typography variant="body1" color="textSecondary">
                      {t("No messages received yet")}
                    </Typography>
                  </div>
                )}
              </List>
            </div>
          )}
          {showMessage && (
            <MessageBody
              handleBack={handleBack}
              message={messageContent}
              handleSetResponse={handleSetResponse}
              senderName={senderName}
              handleResponse={handleReply}
              messageSelected={messageSelected}
              handleMarkRead={handleMarkRead}
              messageResponse={messageResponse}
              loading={loading}
              onRefreshThread={handleRefreshThread}
            />
          )}

          {/* For read Messages */}
          {dashboard === "read" && (
            <div
              className={
                classes.dashboard +
                " mx-1 flex-column justify-content-start py-3"
              }
            >
              <List className={classes.listMessage}>
                {loading && readMessages.length === 0 && (
                  <div className={classes.loadingContainer}>
                    <CircularProgress />
                  </div>
                )}
                {readMessages.length > 0 &&
                  readMessages.map((msg, idx) => (
                    <React.Fragment key={idx}>
                      <ListItem
                        role={undefined}
                        dense
                        button
                        onClick={() => {
                          setShowMessage(true);
                          setMessageContent(msg.content);
                          setSenderName(msg.sender_name);
                          setDashboard(`${dashboard}A`);
                          setPatientEmail(msg.send_by);
                          setReplyMessageId(msg.id);
                          setMessageSelected(msg);
                        }}
                        className={classes.message + " lisItem my-2 p-2"}
                      >
                        <ListItemIcon className={classes.receivedIcon}>
                          <VisibilityIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`${t("From")}: (${
                            msg.other_user?.extendedData?.firstName || ""
                          } ${
                            msg.other_user?.extendedData?.lastname || ""
                          }) at (${new Date(msg.createdAt).toLocaleString()}) - ${t("Message Read")}`}
                        />
                      </ListItem>
                      <Divider className={classes.dividerList} />
                    </React.Fragment>
                  ))}
                {readMessages.length === 0 && !loading && (
                  <div className={classes.emptyState}>
                    <VisibilityIcon style={{ fontSize: 48, opacity: 0.3 }} />
                    <Typography variant="body1" color="textSecondary">
                      {t("No read messages")}
                    </Typography>
                  </div>
                )}
              </List>
            </div>
          )}
          {dashboard === "answered" && (
            <div
              className={
                classes.dashboard +
                " mx-1 flex-column justify-content-start py-3"
              }
            >
              <List className={classes.listMessage}>
                {loading && answeredMessages.length === 0 && (
                  <div className={classes.loadingContainer}>
                    <CircularProgress />
                  </div>
                )}
                {answeredMessages.length > 0 &&
                  answeredMessages.map((msg, idx) => (
                    <React.Fragment key={idx}>
                      <ListItem
                        role={undefined}
                        dense
                        button
                        onClick={() => {
                          setShowMessage(true);
                          setMessageContent(msg.content);
                          setSenderName(msg.sender_name);
                          setDashboard(`${dashboard}A`);
                          setPatientEmail(msg.send_by);
                          setReplyMessageId(msg.id);
                          setMessageSelected(msg);
                        }}
                        className={classes.message + " lisItem my-2 p-2"}
                      >
                        <ListItemIcon className={classes.answeredIcon}>
                          <CheckBoxIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`${t("From")}: (${
                            msg.other_user?.extendedData?.firstName || ""
                          } ${
                            msg.other_user?.extendedData?.lastname || ""
                          }) at (${new Date(msg.createdAt).toLocaleString()}) - ${t("Answered")}`}
                        />
                      </ListItem>
                      <Divider className={classes.dividerList} />
                    </React.Fragment>
                  ))}
                {answeredMessages.length === 0 && !loading && (
                  <div className={classes.emptyState}>
                    <CheckBoxIcon style={{ fontSize: 48, opacity: 0.3 }} />
                    <Typography variant="body1" color="textSecondary">
                      {t("No answered messages")}
                    </Typography>
                  </div>
                )}
              </List>
            </div>
          )}
        </div>
      </div>
    </DashboardPatient>
  );
}

export default InboxPatient;
